// Add Font Awesome
const fontAwesomeLink = document.createElement('link');
fontAwesomeLink.rel = 'stylesheet';
fontAwesomeLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css';
document.head.appendChild(fontAwesomeLink);

export function createMaintenancePage(): HTMLElement {
  const container = document.createElement('div');
  container.style.cssText = `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    text-align: center;
    padding: 40px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background: #242424;
    color: #ffffff;
  `;

  // Icon
  const icon = document.createElement('i');
  icon.className = 'fas fa-cog';
  icon.style.cssText = `
    font-size: 4em;
    background: linear-gradient(45deg, #ff00ff, #00ffff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 20px;
    animation: spin 2s linear infinite;
    text-shadow: 0 0 20px rgba(255, 0, 255, 0.5);
  `;

  // Title
  const title = document.createElement('h1');
  title.textContent = 'We\'ll Be Right Back!';
  title.style.cssText = `
    font-size: 2.5em;
    margin-bottom: 15px;
    font-weight: 600;
    background: linear-gradient(45deg, #ff00ff, #00ffff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 0 20px rgba(255, 0, 255, 0.3);
  `;

  // Message
  const message = document.createElement('p');
  message.textContent = 'We\'re making some improvements to give you a better experience. Please check back in a little while.';
  message.style.cssText = `
    font-size: 1.2em;
    margin-bottom: 30px;
    max-width: 600px;
    line-height: 1.6;
    color: #ffffff;
    opacity: 0.9;
  `;

  // Contact Section
  const contactSection = document.createElement('div');
  contactSection.style.cssText = `
    margin-top: 40px;
    padding: 20px;
    border-top: 1px solid rgba(255, 0, 255, 0.2);
    max-width: 600px;
  `;

  const contactTitle = document.createElement('h2');
  contactTitle.textContent = 'Need Help?';
  contactTitle.style.cssText = `
    font-size: 1.5em;
    margin-bottom: 15px;
    background: linear-gradient(45deg, #ff00ff, #00ffff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  `;

  const contactMessage = document.createElement('p');
  contactMessage.textContent = 'For urgent matters, you can reach out to PLATO5\'s founder, Nick Goldstein, on social media or contact us at our support email.';
  contactMessage.style.cssText = `
    font-size: 1.1em;
    margin-bottom: 20px;
    color: #ffffff;
    opacity: 0.9;
  `;

  // Social Media Links
  const socialLinks = document.createElement('div');
  socialLinks.style.cssText = `
    display: flex;
    gap: 20px;
    justify-content: center;
    margin-top: 20px;
  `;

  const socialPlatforms = [
    { name: 'Instagram', icon: 'fa-instagram', url: 'https://www.instagram.com/goldsteinnick/' },
    { name: 'X (Twitter)', icon: 'fa-twitter', url: 'https://x.com/GoldsteinNichol' },
    { name: 'TikTok', icon: 'fa-tiktok', url: 'https://www.tiktok.com/@goldsteinnick' }
  ];

  socialPlatforms.forEach(platform => {
    const link = document.createElement('a');
    link.href = platform.url;
    link.target = '_blank';
    link.style.cssText = `
      background: linear-gradient(45deg, #ff00ff, #00ffff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-size: 2em;
      transition: all 0.3s ease;
    `;
    link.onmouseover = () => {
      link.style.transform = 'scale(1.2)';
    };
    link.onmouseout = () => {
      link.style.transform = 'scale(1)';
    };

    const icon = document.createElement('i');
    icon.className = `fab ${platform.icon}`;
    link.appendChild(icon);
    socialLinks.appendChild(link);
  });

  // Add animation style
  const style = document.createElement('style');
  style.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    @keyframes glow {
      0% { text-shadow: 0 0 10px rgba(255, 0, 255, 0.5); }
      50% { text-shadow: 0 0 20px rgba(0, 255, 255, 0.8); }
      100% { text-shadow: 0 0 10px rgba(255, 0, 255, 0.5); }
    }
  `;
  document.head.appendChild(style);

  contactSection.appendChild(contactTitle);
  contactSection.appendChild(contactMessage);
  contactSection.appendChild(socialLinks);

  container.appendChild(icon);
  container.appendChild(title);
  container.appendChild(message);
  container.appendChild(contactSection);
  return container;
} 